/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import classes from "./Navbar.module.scss";
import Model from "@tripian/model";
// import darkTripianLogo from "/assets/img/dark-tripian.png";
// import lightTripianLogo from "/assets/img/light-tripian.png";
// import TripianLogo from "/assets/img/tripian-new-icon.png";

type Prop = {
  theme?: "dark" | "light";
  isLanding?: boolean;
  isLoggedIn?: boolean;
  onClickLogin?: () => void;
  onClickRegister?: () => void;
  t: (value: Model.TranslationKey) => string;
};

export const Navbar = ({
  theme = "light",
  isLanding = false,
  isLoggedIn,
  onClickLogin,
  onClickRegister,
  t,
}: Prop) => {
  return (
    <header className={classes.landingHeader}>
      <nav className={classes.landingHeaderNav}>
        <div className={classes.landingBanner}>
          <a title="Tripian">
            <img
              className={classes.landingHeaderTripianLogo}
              src={
                theme === "dark"
                  ? window.tconfig.IMAGE_PATHS.LOGO_PATH_DARK
                  : window.tconfig.IMAGE_PATHS.LOGO_PATH_LIGHT ||
                    "/assets/img/tripian-new-icon.png"
              }
              alt="Tripian"
            />
          </a>

          {isLanding && window.tconfig.BRAND_NAME !== "Tripian" && (
            <div className={classes.landingBannerLogo}>
              <div className={classes.landingBannerLogoText}>
                {t("landing.poweredBy")}
              </div>
              <img
                className={classes.landingBannerLogoImg}
                src={
                  theme === "dark"
                    ? "/assets/img/dark-tripian.png"
                    : "/assets/img/light-tripian.png"
                }
                alt="tripian"
              />
            </div>
          )}
        </div>

        {isLanding && (
          <ul className={classes.landingHeaderMenu}>
            {(window.tconfig.SHOW_REGISTER || isLoggedIn) && (
              <li>
                <a className={classes.active} onClick={onClickRegister}>
                  {t("landing.getStarted")}
                </a>
              </li>
            )}
            {!isLoggedIn && (
              <li>
                <a onClick={onClickLogin}>{t("landing.login")}</a>
              </li>
            )}
          </ul>
        )}
      </nav>
    </header>
  );
};
